var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return ["mobile", "tablet"].includes(_vm.$mq)
    ? _c(
        "carousel",
        {
          staticClass: "steps-carousel",
          attrs: {
            "slides-to-show": _vm.$mq === "mobile" ? 1 : 2.2,
            "center-mode": true,
            infinite: true,
            dots: true,
          },
        },
        _vm._l(_vm.steps, function (step, index) {
          return _c(
            "slide",
            { key: index },
            [_c("subscription-step", { attrs: { step: step, index: index } })],
            1
          )
        }),
        1
      )
    : _c(
        "div",
        { staticClass: "subscription-steps" },
        _vm._l(_vm.steps, function (step, index) {
          return _c("subscription-step", {
            key: index,
            attrs: { step: step, index: index },
          })
        }),
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }